import { DeeplinkKeys } from '@/consts/deepLinks';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import { EDITOR_APP_URL, MOBILE_EDITOR_URL } from '@/consts/urls';

import type { NotificationConfig } from '@/types';

import { createDeeplinkUrl } from './createDeeplinkUrl';
import { extractUrlParams } from './extractUrlParams';

const createNotificationConfig = (): NotificationConfig => {
  const { projectId } = extractUrlParams([DeeplinkKeys.projectId]);

  const deeplink = createDeeplinkUrl({
    baseUrl: EDITOR_APP_URL,
    params: {
      app: MINIAPP_PACKAGE_ID,
      projectId,
      category: 'miniapps',
    },
  });

  const mobileDeeplink = createDeeplinkUrl({
    baseUrl: MOBILE_EDITOR_URL,
    params: {
      mapp: MINIAPP_PACKAGE_ID,
      experience: 'default',
    },
  });

  return {
    ...(projectId && { projectId }),
    miniappPackageId: MINIAPP_PACKAGE_ID,
    actions: [
      {
        deeplink,
        mobileDeeplink,
      },
    ],
  };
};

export { createNotificationConfig };
